export const useTrackAppUsage = (state: string) => {
  const { $store, $analytics } = useNuxtApp();

  $analytics.track('visitedAppView', {
    ...$store.getters['view/viewAppData'],
    state,
  });
};
